exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".zui-page{width:100%;height:100%;margin:0 auto;font-size:.072917rem;padding-top:.3125rem}.zui-page.min-1200{min-width:6.25rem}.zui-page a{cursor:pointer}.zui-page a,.zui-page a:hover{color:inherit}.zui-page .clear:after{content:\"\";display:table;clear:both}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/page.css
// module id = 938
// module chunks = 0